import { defineMessages } from "react-intl"

const messages = defineMessages({
  addIntroduction: {
    id: "article.add-introduction",
    defaultMessage: "Add an introduction (optional)..."
  },
  addTitle: {
    id: "article.add-title",
    defaultMessage: "Add a title..."
  },
  publish: {
    id: "article.publish",
    defaultMessage: "Publish"
  },
  saveChanges: {
    id: "article.save-changes",
    defaultMessage: "Save changes"
  },
  finishEditingSection: {
    id: "article.finish-editing-section",
    defaultMessage: "Finish editing section"
  },
  editSection: {
    id: "article.edit-section",
    defaultMessage: "Edit section"
  },
  moveSectionUpwards: {
    id: "article.move-section-upwards",
    defaultMessage: "Move section upwards"
  },
  moveSectionDownwards: {
    id: "article.move-section-downwards",
    defaultMessage: "Move section downwards"
  },
  deleteSection: {
    id: "article.delete-section",
    defaultMessage: "Delete section"
  },
  removeSectionConfirm: {
    id: "article.delete-section-confirm",
    defaultMessage: "Are you sure you want to remove this section?"
  },
  errorEnterTitle: {
    id: "article.error-enter-title",
    defaultMessage: "Please enter a title for your story"
  },
  errorAgreeToLicense: {
    id: "article.error-agree-to-licenses",
    defaultMessage: "You must to agree to the license"
  },
  createdBy: {
    id: "article.created-by",
    defaultMessage: "Created By"
  },
  place: {
    id: "article.place",
    defaultMessage: "Place"
  },
  share: {
    id: "article.share",
    defaultMessage: "Share"
  },
  download: {
    id: "article.download",
    defaultMessage: "Download"
  },
  objectRights: {
    id: "article.object-rights",
    defaultMessage: "Object rights"
  },
  creditLine: {
    id: "article.credit-line",
    defaultMessage: "Credit Line"
  },
  communityContributed: {
    id: "community-contributed",
    defaultMessage: "Community Contributed"
  },
  addImage: {
    id: "article.add-image",
    defaultMessage: "Add Image"
  },
  addVideo: {
    id: "article.add-video",
    defaultMessage: "Add Video"
  },
  addAudio: {
    id: "article.add-audio",
    defaultMessage: "Add Audio"
  },
  addText: {
    id: "article.add-text",
    defaultMessage: "Add Text"
  },
  add: {
    id: "article.add",
    defaultMessage: "Add"
  },
  addElement: {
    id: "article.add-element",
    defaultMessage: "Add New Element"
  },
  tip: {
    id: "article.tip",
    defaultMessage:
      "<strong>Tip:</strong> When you have added a text block or media item, you can click/tap it to edit it again."
  },
  creation: {
    id: "article.creation",
    defaultMessage: "Creation"
  },
  reportAProblem: {
    id: "article.report-a-problem",
    defaultMessage: "Report a problem"
  },
  content: {
    id: "article.content",
    defaultMessage: "content"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/article.js